/**
 * @file Route: singleproject
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { Header } from "components/Header/Info";
import { $, $all, forEach, on } from "@olmokit/dom";
import "components/Cover";
import "components/Related";
import gallery from "components/Gallery";
// import trackCollectionImpressions from "utils/trackCollectionImpressions";
// import trackCollectionLinks from "utils/trackCollectionLinks";

import { dataLayerSelectItem } from "components/Datalayer"

import "./index.scss";

console.log("Route singleproject/index.js mounted.");

Header();

gallery('');

// trackCollectionImpressions();

// trackCollectionLinks();

const ctas = $all(".dlClickCta");
if (ctas) {
  forEach(ctas, card => {
    on(card, "click", (e) => {
      const $trackData = card.getAttribute('data-track-collection-link')
      const data = JSON.parse($trackData)
      console.log(data.name, data.name, data.variant, '0');
      dataLayerSelectItem(data.name, data.name, data.variant, '0')
      // e.preventDefault()
    });
  });
}